export const andCompare = (value1, value2) => value1 && value2;

export const orCompare = (value1, value2) => value1 || value2;

export const ternary = (condition, value1, value2) =>
  condition ? value1 : value2;

export const ifCallback = (condition, cb1, cb2) => (condition ? cb1() : cb2());
